import { ReactNode } from 'react'
import s from './styles.module.scss'
import cn from 'clsx'

export const ToolTip = ({
  content,
  children,
  toolTipClassName,
}: {
  content?: string | ReactNode
  children?: ReactNode
  toolTipClassName?: string
}) => {
  return (
    <div className={s.container}>
      <span className={cn(s.toolTip, toolTipClassName)}>{content}</span>
      {children}
    </div>
  )
}
